import { render, staticRenderFns } from "./HistoryDataAnggota.vue?vue&type=template&id=93646a10&"
import script from "./HistoryDataAnggota.vue?vue&type=script&lang=js&"
export * from "./HistoryDataAnggota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports